import { useState } from "react"
import Modal from "../../../components/Modal"
import InputText from "../../../components/InputText"
import Button from "../../../components/Button"
import { playerTransfer } from "../../../services/wallet.services"
import { useAppSelector } from "../../../store/store"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const SendCredits = () => {
    const token = useAppSelector(state => state.token)

    const [menuOpen, setMenuOpen] = useState(false)
    const [entity, setEntity] = useState<string | null>(null)
    const [alias, setAlias] = useState<string>("")
    const [amount, setAmount] = useState("0")
    const [requesting, setRequesting] = useState(false)
    const navigate = useNavigate()

    const handleSubmit = () => {
        setRequesting(true)
        playerTransfer({
            entity: entity || "PLAYER",
            alias,
            amount,
            token: token || ""
        })
            .then(() => {
                toast.success("Transferencia enviada")
                navigate(0)
            })
            .catch((error) => toast.error(error.response.data.message))
            .finally(() => setRequesting(false))
    }

    return (
        <>
            <button
                className="text-blue-500 bg-blue-100 py-1 px-2 text-sm font-semibold rounded self-start"
                onClick={() => setMenuOpen(true)}
            >Enviar</button>

            <Modal modalOpen={menuOpen} set={setMenuOpen}>
                <div className="w-[420px] flex flex-col gap-5 bg-white p-5 rounded">
                    <p className="text-zinc-700 text-xl">Enviar créditos</p>
                    {!entity &&
                        <div className="flex gap-2">
                            <button onClick={() => setEntity("PLAYER")} className="flex-auto text-zinc-700 font-semibold border rounded p-4">Jugador</button>
                            <button onClick={() => setEntity("TEAM")} className="flex-auto text-zinc-700 font-semibold border rounded p-4">Equipo</button>
                        </div>
                    }

                    {entity &&
                        <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                                {entity === "PLAYER" && <p className="uppercase text-sm text-zinc-700">Jugador</p>}
                                {entity === "TEAM" && <p className="uppercase text-sm text-zinc-700">Equipos</p>}
                                <button className="text-blue-500 text-sm" onClick={() => setEntity(null)}>Cambiar</button>
                            </div>
                        </div>
                    }
                    {entity && <InputText type="text" placeholder={entity === "PLAYER" ? "Nickname" : "Slug"} onChange={(event) => setAlias(event.target.value)} value={alias} />}
                    <InputText type="number" placeholder="Monto" onChange={(event) => setAmount(event.target.value)} value={amount} />
                    <Button onClick={handleSubmit} spinner={requesting} disabled={requesting}>Enviar</Button>
                </div>
            </Modal >
        </>
    )
}

export default SendCredits